var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('MglMap',{ref:"map",attrs:{"accessToken":_vm.accessToken,"mapStyle":_vm.mapStyle,"zoom":_vm.zoomLvl,"maxZoom":_vm.max,"minZoom":_vm.min,"maxBounds":_vm.maxBounds}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }